module.exports = __webpack_public_path__ + "static/media/lalizlabeth.97a81f02.jpg";